import React, { FC } from 'react';
import { connect } from 'react-redux';
import { trackEvent } from 'dibs-tracking';
import Logo2020 from 'dibs-icons/exports/Logo2020';
import Logo2020Trade from 'dibs-icons/exports/Logo2020Trade';
import LogoVip from 'dibs-icons/exports/LogoVip';
import styles from './LogoNav-style.scss';

const trackingObj = {
    category: 'navigation',
    action: 'header navigation click',
    label: 'home link|1stdibs logo',
};

type Props = {
    isUserTypeTrade?: boolean;
    isUserTypeVip?: boolean;
};

const Logo: FC<Props> = ({ isUserTypeTrade, isUserTypeVip }) => {
    let LogoComponent = Logo2020;
    if (isUserTypeTrade) {
        LogoComponent = Logo2020Trade;
    } else if (isUserTypeVip) {
        LogoComponent = LogoVip;
    }
    return (
        <div className={styles.wrapper}>
            <a
                aria-label="1stDibs"
                href="/"
                className={styles.iconWrapper}
                onClick={() => {
                    trackEvent(trackingObj);
                }}
            >
                <LogoComponent />
            </a>
        </div>
    );
};

type PartialState = {
    header: Props;
};

const mapStateToProps = (state: PartialState): Props => {
    const { isUserTypeTrade, isUserTypeVip } = state.header;
    return {
        isUserTypeTrade,
        isUserTypeVip,
    };
};

export default connect(mapStateToProps)(Logo);
